<script>
import { component as embedComponentsMixin } from '@shared/mixins/embeds';
import utilsMixin from '@shared/mixins/utils';

export default {
  mixins: [embedComponentsMixin, utilsMixin],
  computed: {
    basePrice() {
      const hasPrice = this.buyable.price != null ? this.buyable.price : this.buyable.amount;
      return hasPrice != null ? hasPrice : 0;
    },
    finalPrice() {
      const discountPrice = this.buyable.discount_price;
      return discountPrice != null ? discountPrice : this.basePrice;
    },
  },
  methods: {
    buy() {
      window.parent.postMessage({ name: 'checkout' }, '*');
      this.$gtag.addToCart({
        items: [{
          id: this.buyable.uuid,
          name: this.buyable.name,
          quantity: 1,
          price: this.finalPrice,
        }],
      });
      this.$fbq.addToCart({
        content_ids: [this.buyable.uuid],
        content_name: this.buyable.name,
        value: this.finalPrice,
      });
    },
    theme() {
      return this.$t('embed_button_theme');
    },
  },
  i18n: {
    messages: {
      en: {
        embed_button_theme: 'Access',
        embed_button_free: '(Free)',
        embed_button_instead_of: 'Instead of',
      },
      fr: {
        embed_button_theme: 'Accéder',
        embed_button_free: '(Gratuit)',
        embed_button_instead_of: 'Au lieu de',
      },
    },
  },
};
</script>

<template>
  <div
    class="mw-full is-inline-block px-1 pb-2 has-text-centered"
    :style="{
      width: params['style[width]'],
      maxWidth: '100%',
    }">
    <b-button
      type="is-primary is-custom"
      :style="{
        height: 'auto',
        minHeight: params['style[height]'] || 'auto',
        whiteSpace: 'initial',
        borderRadius: params['style[borderRadius]']
      }"
      expanded
      @click="buy">
      {{ text }}
      <template v-if="params.showPrice">
        <template v-if="finalPrice > 0">
          ({{ finalPrice | formatPrice }})
        </template>
        <template v-else>
          {{ $t('embed_button_free') }}
        </template>
      </template>
    </b-button>
    <p
      v-if="params.showPrice && buyable.discount_price != null"
      class="mt-2">
      {{ $t('embed_button_instead_of') }}
      <span class="tdecoration-line-through">
        <template v-if="basePrice > 0">
          {{ basePrice | formatPrice }}
        </template>
        <template v-else>
          {{ $t('embed_button_free') }}
        </template>
      </span>
    </p>
  </div>
</template>
